import { Fun } from 'widgets-for-react'
import { FeaturedContentBlockStyle } from '../../cms/blocks/widgets/featuredContentBlock.gen'
import { IframeBlockStyle } from '../../cms/blocks/widgets/iframeBlock.gen'
import { ImageGalleryBlockStyle } from '../../cms/blocks/widgets/imageGalleryBlock.gen'
import { LinkBlockStyle } from '../../cms/blocks/widgets/linkBlock.gen'
import { TextImageBlockStyle } from '../../cms/blocks/widgets/textImageBlock.gen'
import { TextReadMoreBlockStyle } from '../../cms/blocks/widgets/textReadMoreBlock.gen'
import { DoubleTextImageBlockStyle } from './custom_blocks/widgets/doubleTextImage'


// ⚠️ DEPRECATED WARNING: This file is deprecated and will be removed in the future as redesign is implemented. Please put classnames directly inside the (new) layouts in the Main/Modules/VanOord.CMS folder.


export const featuredContentClasses: Fun<'left' | 'right', FeaturedContentBlockStyle> = (imageDirection) => ({
  // block_classname: `block block--featured image--${imageDirection} spacing--m`,
  // inner_classname: 'block__inner',
  // header_classname: 'block__header',
  // label_classname: 'block__label label--m',
  // title_classname: 'block__title title--m',
  // subtitle_classname: 'block__subtitle title--s',
  // content_classname: 'block__content',
  // text_classname: 'block__text',
  // clickable_primary_classname: 'block__action link',
  // figure_classname: 'block__visual',
  // image_classname: 'block__image'
})

export const textImageClasses: Fun<'left' | 'right', TextImageBlockStyle> = (imageDirection) => ({
  block_classname: `block block--image-text block--image-${imageDirection} ls-block-spacing`,
  inview_classname: `block__inview`,
  inner_classname: `block__inner ls-container`,
  content_classname: `block__content`,
  header_classname: `block__header`,
  label_classname: `block__label`,
  title_classname: `block__title title--l`,
  subtitle_classname: `block__subtitle`,
  text_classname: `block__text`,
  intro_classname: `block__intro`,
  footer_classname: `block__footer`,
  clickable_wrapper_classname: `block__clickable`,
  clickable_primary_classname: `link`,
  clickable_secondary_classname: `link`,
  figure_classname: `block__visual`,
  image_classname: `block__image`
})

export const doubleTextImageClasses: Fun<'left' | 'right', DoubleTextImageBlockStyle> = (imageDirection) => ({
  block_classname: `block block--image-text block--image-${imageDirection} ls-block-spacing`,
  inview_classname: `block__inview`,
  inner_classname: `block__inner ls-container`,
  content_classname: `block__content`,
  header_classname: `block__header`,
  label_classname: `block__label`,
  title_classname: `block__title title--l`,
  subtitle_classname: `block__subtitle`,
  text_classname: `block__text`,
  intro_classname: `block__intro`,
  footer_classname: `block__footer`,
  clickable_wrapper_classname: `block__clickable`,
  clickable_primary_classname: `link`,
  clickable_secondary_classname: `link`,
  figure_classname: `block__visual`,
  image_classname: `block__image`
})


export const textReadMoreBlockClasses: TextReadMoreBlockStyle = {}

export const linkListBlockClasses: LinkBlockStyle = {
  block_classname: 'block block--link block--lists ls-block-spacing',
  inner_classname: 'block__inner ls-container',
  header_classname: 'block__header',
  title_classname: 'block__title title--l',
  intro_classname: 'block__intro',
  content_classname: 'block__content',
  list_classname: 'block__list blocklist',
  item_classname: 'block__item blocklist__item',
  link_classname: 'block__link blocklist__link',
  link_label_classname: 'blocklist__title icon--link',
  link_text_classname: 'blocklist__subtitle',
  link_icon_classname: 'blocklist__icon',
  icon_external_id: '#icon--box',
  icon_internal_id: '#icon--box'
}

export const iframeBlockClasses: IframeBlockStyle = {
  block_classname: 'block block--iframe ls-block-spacing',
  inner_classname: 'block__inner ls-container',
  content_classname: 'block__content',
  iframe_classname: 'block__iframe',
  cookies_classname: 'cookies bg--secondary',
  cookies_inner_classname: 'cookies__inner ls-gutter',
  cookies_text_classname: 'cookies__text text--styled',
  cookies_clickable_classname: 'cookies__clickable link'
}

export const hubspotIframeBlockClasses: IframeBlockStyle = {
  block_classname: 'block block--iframe-hubspot ls-block-spacing',
  inner_classname: 'block__inner ls-container',
  content_classname: 'block__content',
  iframe_classname: 'block__iframe',
  cookies_classname: 'cookies bg--secondary',
  cookies_inner_classname: 'cookies__inner ls-gutter',
  cookies_text_classname: 'cookies__text text--styled',
  cookies_clickable_classname: 'cookies__clickable link'
}

export const imageGalleryBlockClasses: ImageGalleryBlockStyle = {
  block_classname: 'block block--gallery ls-block-spacing',
  alt_block_classname: 'block block--images ls-block-spacing',
  inner_classname: 'block__inner ls-container',
  header_classname: 'block__header',
  title_classname: 'block__title title--l',
  intro_classname: 'block__intro',
  content_classname: 'block__content',
  gallery_list_classname: 'block__list gallery',
  alt_gallery_list_classname: 'block__list grid',
  gallery_item_classname: 'gallery__item',
  alt_gallery_item_classname: 'grid__item',
  gallery_button_classname: 'gallery__button fit-object',
  alt_gallery_button_classname: 'grid__visual fit-object',
  gallery_image_classname: 'gallery__image',
  gallery_toggle_classname: 'gallery__toggle title--m',
  lightbox_classname: 'lightbox',
  lightbox_inner_classname: 'lightbox__inner ls-container',
  lightbox_nav_classname: 'lightbox__nav',
  lightbox_nav_inner_classname: 'lightbox__nav-inner',
  lightbox_close_classname: 'lightbox__close',
  lightbox_figure_classname: 'lightbox__figure',
  lightbox_visual_classname: 'lightbox__visual ls-container',
  lightbox_image_classname: 'lightbox__image',
  lightbox_figcaption_classname: 'lightbox__figcaption block__figcaption',
  lightbox_caption_classname: 'lightbox__caption',
  lightbox_source_classname: 'lightbox__source block__source tag--m',
  lightbox_controls_classname: 'lightbox__controls',
  lightbox_controls_inner_classname: 'lightbox__controls-inner',
  lightbox_next_classname: 'lightbox__control lightbox__control--next',
  lightbox_prev_classname: 'lightbox__control lightbox__control--previous',
  icon_close_id: '',
  icon_next_id: '',
  icon_previous_id: ''
}